export const SET_CART_DETAIL = "SET_CART_DETAIL";
export const SET_HOME_BRAND = "SET_HOME_BRAND";
export const SET_ORDER_SUCCESS = "SET_ORDER_SUCCESS";
export const SET_MENU = "SET_MENU";
export const SET_VERSION_MENU = "SET_VERSION_MENU";
export const SET_SERVING_CONTEXT = "SET_SERVING_CONTEXT";
export const SET_IS_NEED_REFRESH_MENU = "SET_IS_NEED_REFRESH_MENU";
export const SET_IS_REFRESH_PAGE = "SET_IS_REFRESH_PAGE";
export const SET_IS_BF_PENDING_DISH = "SET_IS_BF_PENDING_DISH";
export const SET_KALO_GROUP_PENDING = "SET_KALO_GROUP_PENDING";
export const SET_IS_SHOW_MESSAGE = "SET_IS_SHOW_MESSAGE";
export const SET_QUANTITY_FOOD_WASTED = "SET_QUANTITY_FOOD_WASTED";
export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";
export const SET_OUT_OF_DISH_VERSION = "SET_OUT_OF_DISH_VERSION";
export const SET_BUFFET_ITEM = "SET_BUFFET_ITEM";
export const SET_ALC_ITEM = "SET_ALC_ITEM";
export const SET_TAB_ACTIVE = "SET_TAB_ACTIVE";
export const SET_POSITION_SCROLL = "SET_POSITION_SCROLL";
export const SET_IS_HIDE_PRICE = "SET_IS_HIDE_PRICE";
export const SET_LIST_SESSION = "SET_LIST_SESSION";
export const SET_BUFFET_TICKET = "SET_BUFFET_TICKET";
export const SET_IS_CHECK_COMMENT = "SET_IS_CHECK_COMMENT";
export const SET_TIP_TOP_DOWN = "SET_TIP_TOP_DOWN";
export const SET_BF_EXTRA_COUNT_CHILDREN = "BF_EXTRA_COUNT_CHILDREN";
export const FW_SUBMIT_FOR_ROUND_DEFAULT = "FW_SUBMIT_FOR_ROUND_DEFAULT";
export const FW_SUBMIT_FOR_LESS_THAN_THREE_GUEST =
  "FW_SUBMIT_FOR_LESS_THAN_THREE_GUEST";
export const SET_SHOW_TAB_ON_CART = "SET_SHOW_TAB_ON_CART";
export const SET_DATA_INFO_VAT = "SET_DATA_INFO_VAT";
export const SET_DATA_INFO_USER_TGS = "SET_DATA_INFO_USER_TGS";
export const SET_DATA_USER_SESSION = "SET_DATA_USER_SESSION";
export const SET_PAYMENT_PARTNER = "SET_PAYMENT_PARTNER";
export const FUNC_SHOW_PAYMENT_QR_ORDER = "FUNC_SHOW_PAYMENT_QR_ORDER";
export const SET_DRAFT_HOME_BRAND = "SET_DRAFT_HOME_BRAND";
export const SET_IS_POINT_ONEMOUNT = "SET_IS_POINT_ONEMOUNT";
export const SET_FEEDBACK_CONFIG = "SET_FEEDBACK_CONFIG";
export const SET_FEEDBACK_CONFIG_CONTENT = "SET_FEEDBACK_CONFIG_CONTENT";
export const SET_SIZE_IN_HOME = "SET_SIZE_IN_HOME";
export const SET_VERTICAL_LAYOUT_QR_ORDER = "SET_VERTICAL_LAYOUT_QR_ORDER";
export const SHOW_TOTAL_PRICE_APPLY_DISCOUNT =
  "SHOW_TOTAL_PRICE_APPLY_DISCOUNT";
export const TIP_SUGGEST_BY_PERCENT = "TIP_SUGGEST_BY_PERCENT";
export const COMBO_CUSTOM_PRICE = "COMBO_CUSTOM_PRICE";
export const COMBO_CUSTOM_PRICE_ONLY_SELECT = "COMBO_CUSTOM_PRICE_ONLY_SELECT";
export const API_ERROR_UPDATE = "API_ERROR_UPDATE";
export const API_ERROR_PUSH = "API_ERROR_PUSH";
export const API_ERROR_OPEN = "API_ERROR_OPEN";
export const NO_INTERNET = "NO_INTERNET";
export const SET_PARAMS_HOTPOT_BF = "SET_PARAMS_HOTPOT_BF";
export const GET_PARAMS_HOTPOT_BF = "GET_PARAMS_HOTPOT_BF";
export const SET_IS_BF_MENU = "SET_IS_BF_MENU";
export const SET_HOTPOT_GUIDELINE_DISPLAYED = "SET_HOTPOT_GUIDELINE_DISPLAYED";
export const SET_ORDER_OVERVIEW = "SET_ORDER_OVERVIEW";
export const HOTPOT_SELECTING = "HOTPOT_SELECTING";
export const HIDDEN_FREE_SOUP = "HIDDEN_FREE_SOUP";
export const ONBOARDING_URL = "ONBOARDING_URL";
export const SET_COMENUGROUP_HOTPOT = "SET_COMENUGROUP_HOTPOT";
export const SET_MAXIMUM_DISHES_BEING_SERVED = "MAXIMUM_DISHES_BEING_SERVED";
export const FUNC_SHOW_TIPPING = "FUNC_SHOW_TIPPING";
export const TIP_SUGGEST_BY_PERCENT_HIGH = "TIP_SUGGEST_BY_PERCENT_HIGH";
export const TIP_TOP_DOWN_HIGH = "TIP_TOP_DOWN_HIGH";
export const USER_DEFAULT_OPEN_TABLE_QR_STATIC = "USER_DEFAULT_OPEN_TABLE_QR_STATIC";
export const VISIBLE_MENU_BY_WEEKDAYS = "VISIBLE_MENU_BY_WEEKDAYS";
export const VISIBLE_MENU_BY_SPECIAL_DAYS = "VISIBLE_MENU_BY_SPECIAL_DAYS";
export const SET_TAKE_TAX = "SET_TAKE_TAX";
export const SET_INFO_TGS_V3 = "SET_INFO_TGS_V3";
export const ALLOW_EXPEDITE_FULL_ORDER = "ALLOW_EXPEDITE_FULL_ORDER";
export const TABLE_CODE = "TABLE_CODE";
export const SET_PARAM_CONFIG = "SET_PARAM_CONFIG";





